import InboxMsg from "./InboxMsg";

export default InboxMsg;
